import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import debounce from 'lodash.debounce';
import { Button, CloseButton, FormControl, FormLabel, IconButton, Input, InputGroup, InputLeftElement, InputRightElement, Select, useDisclosure } from "@chakra-ui/react";
import InputField from "components/fields/InputField";
import Modal from "components/modal/Modal";
import { FaAddressBook, FaEdit, FaPencilAlt, FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import TooltipComponent from "components/tooltip";
import { FiSearch } from "react-icons/fi";
import ButtonPrimary from "components/button/ButtonPrimary";
import { IoAddCircle, IoClose } from "react-icons/io5";
import { SET_TO_DEFAULT_RESPONSE, create, update, del, getByPage } from "../../../store/features/slices/operacionSlice";
import { SET_TO_DEFAULT_RESPONSE as SET_TO_DEFAULT_RESPONSE_MOV, create as createMovimiento, get, del as delMov } from "../../../store/features/slices/movimientoSlice";
import { get as getUsers, SET_TO_DEFAULT_RESPONSE as SET_TO_DEFAULT_RESPONSE_USER } from "../../../store/features/slices/userSlice";
import { message as alerta } from "utils/Funciones";
import { uriSerialized } from "utils/uriSerialized";
import { alertaConfirmar } from "utils/Funciones";
import SwitchToggle from "components/fields/SwitchToggle";
import moment from "moment"
import 'moment/locale/es';
import TextField from "components/fields/TextField";
import AutoComplete from "components/autocomplete/AutoComplete";
import TablePagination from "./table/TablePagination";

const Operacion = () => {
    const dispatch = useDispatch();
    const { userToken, data: users } = useSelector((state) => state.userReducer);
    const {
        dataByPage,
        totalPage,
        totalRow,
        responseSuccessCreate,
        isLoading,
        isSuccess,
        isError,
        message,
        responseSuccessDelete,
        responseSuccessUpdate
    } = useSelector((state) => state.operacionReducer);

    const {
        data: movimientos,
        isMutation
    } = useSelector((state) => state.movimientoReducer);

    const registrar = useDisclosure()
    const editar = useDisclosure()
    const movimiento = useDisclosure()
    const [searchTerm, setSearchTerm] = useState('');

    const [statemovimiento, setStateMovimiento] = useState({
        name: ''
    })
    const [state, setState] = useState({
        created_at: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
        tipo: '',
        razon: '',
        acreedor: '',
        detalles: '',
        monto: 0,
    })

    const [stateEdit, setStateEdit] = useState({
        _id: '',
        created_at: null,
        tipo: '',
        razon: '',
        acreedor: '',
        detalles: '',
        monto: 0,
        last_update: ''

    })

    function handleEdit(row) {
        setStateEdit({
            ...stateEdit,
            _id: row._id,
            created_at: moment(row.created_at).format("YYYY-MM-DDTHH:mm:ss"),
            tipo: row.tipo,
            razon: row.movimiento._id,
            acreedor: row.acreedor._id,
            detalles: row.detalles,
            monto: row.monto,
            last_update: row.last_update
        })
        editar.onOpen()
    }

    function handleDelete(row) {
        alertaConfirmar('Eliminar operación', `Estas seguro que quieres eliminar la operación <b>${row.movimiento.name}</b>? recuerda que se eliminarán todos los datos relacionados a este.`, 'question', async (res_alert) => {
            if (res_alert === true) {
                await dispatch(del({ _id: row._id, token: userToken }));
            }
        })
    }

    const handleInputs = e => {
        setState({ ...state, [e.target.name]: e.target.value })
    }

    const handleEditInputs = e => {
        setStateEdit({ ...stateEdit, [e.target.name]: e.target.value })
    }

    const onSubmitRegistrar = async e => {
        e.preventDefault();
        if (state.monto < 1) {
            alerta('el monto debe ser mayor a cero', 'error', 4)
        } else if (state.acreedor.trim().length < 1) {
            alerta('acreedor es requerido', 'error', 4)
        } else if (state.razon.trim().length < 1) {
            alerta('naturaleza del pago es requerido', 'error', 4)
        } else if (state.tipo.trim().length < 1) {
            alerta('tipo de operacion es requerido', 'error', 4)
        } else if (new Date(state.created_at).getTime() > Date.now()) {
            alerta('La fecha no puede ser mayor a hoy', 'error', 4)
        } else {
            const formData = new FormData();
            formData.append('data', JSON.stringify(state));
            await dispatch(create({ formData: formData, token: userToken }));
        }
    }

    const onSubmitRegistrarMovimiento = async e => {
        e.preventDefault();
        if (statemovimiento.name.trim().length < 1) {
            alerta('el nombre es requerido', 'error', 4)
        } else {
            const formData = new FormData();
            formData.append('data', JSON.stringify(statemovimiento));
            await dispatch(createMovimiento({ formData: formData, token: userToken }));
        }
    }

    const handleDelMovimiento = () => {
        if (state.razon.trim().length > 0) {
            dispatch(delMov({ _id: state.razon, token: userToken }))
        } else {
            alerta('selecciona el movimiento que quieres eliminar', 'error', 5)
        }
    }

    const handleDelMovimientoEdit = () => {
        if (stateEdit.razon.trim().length > 0) {
            dispatch(delMov({ _id: stateEdit.razon, token: userToken }))
        } else {
            alerta('selecciona el movimiento que quieres eliminar', 'error', 5)
        }
    }

    const onSubmitEditar = async e => {
        e.preventDefault();
        if (stateEdit.monto < 1) {
            alerta('el monto debe ser mayor a cero', 'error', 4)
        } else if (stateEdit.acreedor.trim().length < 1) {
            alerta('acreedor es requerido', 'error', 4)
        } else if (stateEdit.razon.trim().length < 1) {
            alerta('naturaleza del pago es requerido', 'error', 4)
        } else if (stateEdit.tipo.trim().length < 1) {
            alerta('tipo de operacion es requerido', 'error', 4)
        } else if (new Date(stateEdit.created_at).getTime() > Date.now()) {
            alerta('La fecha no puede ser mayor a hoy', 'error', 4)
        } else {
            const formData = new FormData();
            formData.append('data', JSON.stringify(stateEdit));
            await dispatch(update({ formData: formData, token: userToken }));

        }
    }

    useEffect(() => {
        if (isMutation.success) {
            alerta(isMutation.message, 'success', 5)
            setState({ ...state, razon: "" })
            dispatch(SET_TO_DEFAULT_RESPONSE_MOV())
            dispatch(get(userToken));
            movimiento.onClose()
        } else {
            dispatch(get(userToken));
            dispatch(getUsers(userToken));
        }

    }, [dispatch, isMutation.success])

    useEffect(() => {
        if (responseSuccessCreate) {
            alerta(responseSuccessCreate.message, 'success', 5)
            setState({ ...state, name: "", direccion: "" })
            registrar.onClose()
        }
        dispatch(SET_TO_DEFAULT_RESPONSE())
    }, [responseSuccessCreate])

    useEffect(() => {
        if (responseSuccessDelete) {
            alerta(responseSuccessDelete.message, 'success', 5)
        }
        dispatch(SET_TO_DEFAULT_RESPONSE())
    }, [responseSuccessDelete])

    useEffect(() => {
        if (responseSuccessUpdate) {
            alerta(responseSuccessUpdate.message, 'success', 5)
            setState({ ...state, name: "", direccion: "" })
            editar.onClose()
        }
        dispatch(SET_TO_DEFAULT_RESPONSE())
    }, [responseSuccessUpdate])

    const fetchData = useCallback(
        (pageSize, pageIndex, search, order) => {
            const queryOptions = {
                page: pageIndex,
                limit: pageSize,
                search: search,
                order: order,
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            dispatch(getByPage({ query: query, token: userToken }))
        },
        [responseSuccessDelete, responseSuccessCreate]
    )

    const onChangeSearchTerm = e => {
        setSearchTerm(e.target.value);
    };

    const onChangeSearchTermClear = e => {
        setSearchTerm("");
        document.getElementById("search").value = "";
    };

    const debounceSearchTerm = useMemo(() => debounce(onChangeSearchTerm, 700), []);

    return (
        <div className="mt-4 md:mt-0">
            <div className="sticky z-30 w-full top-44 md:top-28 flex items-center justify-end bg-white dark:!bg-navy-800 p-2 rounded-xl shadow-xl shadow-gray-200 dark:shadow-none">
                <div className="relative flex h-[61px] w-[calc(100%-55px)] flex-grow items-center gap-2 rounded-full bg-white px-0 py-2 dark:!bg-navy-800">
                    <InputGroup className="!w-full md:!w-[300px]">
                        <InputLeftElement pointerEvents="none" className="!mt-1 !ml-1">
                            <FiSearch size={24} className="text-navy-500 dark:text-navy-300" />
                        </InputLeftElement>
                        <Input size='lg' autoFocus id="search" onChange={debounceSearchTerm} type="text" placeholder={`Buscar ${totalRow} gastos e ingresos...`} className="flex w-full items-center justify-center !rounded-xl border !bg-lightPrimary 
            dark:!bg-navy-900 !text-sm !ring-none focus:!ring-brand-500 
            focus:!border-brand-500 dark:focus:!ring-brand-400 dark:focus:!border-brand-400 
            !outline-none !border-gray-200 dark:!border-white/10 dark:text-white" />
                        <InputRightElement className="!mt-1">
                            <CloseButton onClick={onChangeSearchTermClear} size='md' className={`mr-2 ${searchTerm.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-navy-500 dark:text-navy-300`} />
                        </InputRightElement>
                    </InputGroup>
                </div>
                <div className="w-[55px] h-[61px] flex items-center">
                    <TooltipComponent
                        trigger={<button onClick={registrar.onOpen} className="bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 flex items-center justify-center rounded-full p-3 text-3xl text-white transition duration-200 hover:cursor-pointer dark:text-white">
                            <FaPlusCircle />
                        </button>}
                        content={
                            <p className="dark:text-white">
                                registrar operación
                            </p>
                        }
                    />
                </div>
            </div>
            <div className="mt-3 md:mt-8">

                {/** REGISTRAR */}
                <Modal isOpen={registrar.isOpen} onClose={registrar.onClose} headerTitle='Registrar operación'>
                    <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                        <form className="w-full" onSubmit={onSubmitRegistrar}>
                            <div className="flex flex-wrap">
                                <InputField
                                    autoFocus={true}
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Fecha de registro"
                                    placeholder="Fecha de registro"
                                    id="created_at"
                                    type="datetime-local"
                                    name="created_at"
                                    onChange={handleInputs}
                                    value={state.created_at}
                                />

                                <AutoComplete
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="tipo"
                                    data={[
                                        { code: '01', name: 'Ingreso' },
                                        { code: '02', name: 'Egreso' },
                                    ]}
                                    value={state.tipo}
                                    required={true}
                                    labelProp="name"
                                    valueProp="code"
                                    onChange={(val) => setState({ ...state, tipo: val })}
                                />

                                <FormControl className="!w-full md:!w-4/12 !mb-3 !p-2 z-10" isRequired={true}>
                                    <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-bold">Naturaleza del pago</FormLabel>
                                    <InputGroup>
                                        <Button onClick={movimiento.onOpen} colorScheme={'brand'} className="flex !px-10 !h-12 !w-24 items-center justify-center w-full !mr-2 rounded-xl bg-brand-500 !py-[14px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200" type="button" fontSize='1em'>
                                            Agregar
                                        </Button>
                                        <AutoComplete
                                            extra="w-full"
                                            data={movimientos}
                                            value={state.razon}
                                            labelProp="name"
                                            valueProp="_id"
                                            onChange={(val) => setState({ ...state, razon: val })}
                                        />
                                        <Button onClick={handleDelMovimiento} colorScheme={'red'} className="flex !h-12 !w-14 items-center justify-center w-full !ml-2 rounded-xl bg-red-500 !py-[14px] text-base font-medium text-white transition duration-200 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200" type="button" fontSize='1em'>
                                            <FaTrashAlt size={24} />
                                        </Button>
                                    </InputGroup>
                                </FormControl>

                                <AutoComplete
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Acreedor"
                                    data={users}
                                    value={state.acreedor}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setState({ ...state, acreedor: val })}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Monto"
                                    placeholder="Monto"
                                    id="monto"
                                    type="number"
                                    max={50000}
                                    name="monto"
                                    onChange={handleInputs}
                                    value={state.monto}
                                />

                                <TextField
                                    required={false}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Detalles"
                                    placeholder="Detalles"
                                    id="detalles"
                                    name="detalles"
                                    maxLength={65}
                                    onChange={handleInputs}
                                    value={state.detalles}
                                />

                                <ButtonPrimary isLoading={isLoading} disabled={false} icon={<IoAddCircle size={28} />}>
                                    Registrar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </Modal>

                <Modal isOpen={movimiento.isOpen} onClose={movimiento.onClose} headerTitle='Registrar movimiento'>
                    <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                        <form className="w-full" onSubmit={onSubmitRegistrarMovimiento}>
                            <div className="flex flex-wrap">
                                <InputField
                                    autoFocus={true}
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    id="name"
                                    type="text"
                                    name="name"
                                    onChange={(e) => setStateMovimiento({ ...statemovimiento, name: e.target.value })}
                                    value={statemovimiento.created_at}
                                />

                                <ButtonPrimary isLoading={isMutation.loading} disabled={false} icon={<IoAddCircle size={28} />}>
                                    Registrar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </Modal>

                {/** EDITAR */}
                <Modal isOpen={editar.isOpen} onClose={editar.onClose} headerTitle='Editar operación'>
                    <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                        <form className="w-full" onSubmit={onSubmitEditar}>
                            <div className="flex flex-wrap">
                                <InputField
                                    autoFocus={true}
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Fecha de registro"
                                    placeholder="Fecha de registro"
                                    id="created_at"
                                    type="datetime-local"
                                    name="created_at"
                                    onChange={handleEditInputs}
                                    value={stateEdit.created_at}
                                />

                                <AutoComplete
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="tipo"
                                    data={[
                                        { code: '01', name: 'Ingreso' },
                                        { code: '02', name: 'Egreso' },
                                    ]}
                                    value={stateEdit.tipo}
                                    required={true}
                                    labelProp="name"
                                    valueProp="code"
                                    onChange={(val) => setStateEdit({ ...stateEdit, tipo: val })}
                                />

                                <FormControl className="!w-full md:!w-4/12 !mb-3 !p-2 z-10" isRequired={true}>
                                    <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-bold">Naturaleza del pago</FormLabel>
                                    <InputGroup>
                                        <Button onClick={movimiento.onOpen} colorScheme={'brand'} className="flex !px-10 !h-12 !w-24 items-center justify-center w-full !mr-2 rounded-xl bg-brand-500 !py-[14px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200" type="button" fontSize='1em'>
                                            Agregar
                                        </Button>

                                        <AutoComplete
                                            extra="w-full"
                                            data={movimientos}
                                            value={stateEdit.razon}
                                            required={true}
                                            labelProp="name"
                                            valueProp="_id"
                                            onChange={(val) => setStateEdit({ ...stateEdit, razon: val })}
                                        />

                                        <Button onClick={handleDelMovimientoEdit} colorScheme={'red'} className="flex !h-12 !w-14 items-center justify-center w-full !ml-2 rounded-xl bg-red-500 !py-[14px] text-base font-medium text-white transition duration-200 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200" type="button" fontSize='1em'>
                                            <FaTrashAlt size={24} />
                                        </Button>
                                    </InputGroup>
                                </FormControl>

                                <AutoComplete
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Acreedor"
                                    data={users}
                                    value={stateEdit.acreedor}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setStateEdit({ ...stateEdit, acreedor: val })}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Monto"
                                    placeholder="Monto"
                                    id="monto"
                                    type="number"
                                    max={50000}
                                    name="monto"
                                    onChange={handleEditInputs}
                                    value={stateEdit.monto}
                                />

                                <TextField
                                    required={false}
                                    variant="input"
                                    extra="w-full md:w-4/12 mb-3 p-2"
                                    label="Detalles"
                                    placeholder="Detalles"
                                    id="detalles"
                                    name="detalles"
                                    maxLength={65}
                                    onChange={handleEditInputs}
                                    value={stateEdit.detalles}
                                />

                                <InputField
                                    required={false}
                                    readOnly={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Última vez que se actualizó"
                                    placeholder="Última vez que se actualizó"
                                    id="last_update"
                                    type="text"
                                    name="last_update"
                                    value={moment(stateEdit.last_update).format('dddd, D [de] MMMM [de] YYYY, h:mm a')}
                                />

                                <ButtonPrimary isLoading={isLoading} disabled={false} icon={<FaEdit size={28} />}>
                                    Editar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </Modal>

                <div className="mt-5 grid h-full grid-cols-1">

                    <TablePagination
                        searchTerm={searchTerm}
                        tableData={dataByPage}
                        fetchData={fetchData}
                        loading={isLoading}
                        pageCount={totalPage}
                        totalRow={totalRow}
                        actions={{
                            onEdit: (item) => handleEdit(item),
                            onDelete: (item) => handleDelete(item)
                        }}
                    />
                </div>
            </div>
        </div >

    );
};

export default Operacion;
